window.addEventListener('DOMContentLoaded', () => {
  if (!window.loadedAccordion) {
    window.loadedAccordion = true;
    class Accordion extends HTMLElement {
      constructor(contentSelector) {
        super();

        this.contentSelector = contentSelector;

        // reset all tabindexes to -1, then set all links in newActiveEl tabindex to 0
        this.querySelectorAll('[class$="accordion"]').forEach((el) => this.setLinkTabIndex(el, -1));

        this.getActiveElement();
        // Sets maxHeight of initial active element so it transitions correctly
        if (this.activeEl) {
          this.activeEl.querySelector(this.contentSelector).style.maxHeight =
            this.activeEl.querySelector(this.contentSelector).children[0].scrollHeight + 'px';
          this.setLinkTabIndex(this.activeEl, 0);
        }

        this.addClickListener();
      }

      setLinkTabIndex(content, tabindex) {
        content.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', tabindex));
      }

      getActiveElement() {
        this.activeEl = [...this.children].find((el) => el.classList.contains('active'));
      }

      closeEl(el) {
        el.querySelector(this.contentSelector).style.maxHeight = null;
        el.classList.remove('active');
      }

      toggleActive(newActiveEl, closeOthers = true) {
        if (closeOthers && this.activeEl) this.closeEl(this.activeEl);
        this.activeEl = newActiveEl;

        const contentEl = newActiveEl.querySelector(this.contentSelector);
        if (contentEl.style.maxHeight) {
          contentEl.style.maxHeight = null;
          newActiveEl.classList.remove('active');
        } else {
          contentEl.style.maxHeight = contentEl.children[0].scrollHeight + 'px';
          newActiveEl.classList.add('active');
        }

        // reset all tabindexes to -1, then set all links in newActiveEl tabindex to 0
        this.querySelectorAll('[class$="accordion"]').forEach((el) => this.setLinkTabIndex(el, -1));
        this.setLinkTabIndex(this.activeEl, 0);
      }

      clickHandler(e) {
        const newActiveEl = e.currentTarget;
        if (!newActiveEl.classList.contains('active')) {
          this.toggleActive(newActiveEl);
        }
      }

      addClickListener() {
        [...this.children].forEach((child) => child.addEventListener('click', this.clickHandler.bind(this)));
      }
    }

    class ProductInfoAccordions extends Accordion {
      constructor() {
        super('.product-info-accordion__content');
      }

      toggleActive(newActiveEl, closeOthers = false) {
        if (newActiveEl.isEqualNode(this.activeEl)) {
          this.closeEl(this.activeEl);
          this.activeEl = null;
          return;
        }
        const oldActiveContentEl = this.activeEl && this.activeEl.querySelector('.product-info-accordion__content');
        super.toggleActive(newActiveEl, closeOthers);

        const headerEl = document.querySelector('#shopify-section-header');
        // const top = this.getBoundingClientRect().top + window.scrollY - (headerEl ? headerEl.offsetHeight : 0) - 10; // 10px padding
        // if (oldActiveContentEl && oldActiveContentEl.getBoundingClientRect().top < 0)
        // window.scrollTo({ top: top, behavior: "smooth" });
      }

      clickHandler(e) {
        const newActiveEl = e.currentTarget;
        this.toggleActive(newActiveEl);
      }
    }

    customElements.define('product-info-accordions', ProductInfoAccordions);

    class ProductTabsAccordions extends Accordion {
      constructor() {
        super('.product-tabs-accordion__content');

        this.loadButton = this.querySelector('[data-load-all]');
        this.drawers = this.querySelectorAll('[data-accordion-drawer]');
        this.loadButton.addEventListener('click', this.loadAllHandler.bind(this));
      }
      toggleActive(newActiveEl, closeOthers = false) {
        if (newActiveEl.isEqualNode(this.activeEl)) {
          this.closeEl(this.activeEl);
          this.activeEl = null;
          return;
        }
        super.toggleActive(newActiveEl, closeOthers);
      }

      clickHandler(e) {
        const newActiveEl = e.currentTarget;
        this.toggleActive(newActiveEl);
      }

      loadAllHandler() {
        [...this.drawers].forEach((drawer) => {
          drawer.classList.remove('hidden');
        });
        this.loadButton.classList.add('hidden');
      }
    }

    customElements.define('product-tabs-accordions', ProductTabsAccordions);

    class FaqAccordions extends Accordion {
      constructor() {
        super('.faq-accordion__answer');
      }

      clickHandler(e) {
        const newActiveEl = e.currentTarget;
        this.toggleActive(newActiveEl, false);
      }
    }

    customElements.define('faq-accordions', FaqAccordions);

    class ProductTabAccordion extends FaqAccordions {
      constructor() {
        super('.faq-accordion__answer');
        this.load_all_button = this.querySelector('[data-load-all]');
        this.accordions = this.querySelectorAll('[data-accordion]');
        this.load_all_button.addEventListener('click', this.handleLoadAll.bind(this));
      }

      handleLoadAll = () => {
        this.accordions.forEach((el) => {
          el.classList.remove('hidden');
        });
        this.load_all_button.classList.add('hidden');
      };
    }
    customElements.define('product-tab-accordion', ProductTabAccordion);

    class AccordionImageSectionAccordions extends Accordion {
      constructor() {
        super('.accordion-image__accordion__content');
      }

      toggleActive(newActiveEl, closeOthers = true) {
        super.toggleActive(newActiveEl, closeOthers);

        const mainEl = this.parentNode.parentNode.parentNode;
        const index = [...this.querySelectorAll('.accordion-image__accordion')].findIndex((el) => el.classList.contains('active'));
        const image_groups = mainEl.querySelectorAll('.accordion-image__image-group');
        image_groups.forEach((image_group) => image_group.classList.remove('active'));
        image_groups[index].classList.add('active');
      }
    }

    customElements.define('accordion-image-section-accordions', AccordionImageSectionAccordions);

    class AccordionImageOrVideoSectionAccordions extends Accordion {
      constructor() {
        super('.accordion-image-or-video__accordion__content');
      }

      toggleActive(newActiveEl, closeOthers = true) {
        super.toggleActive(newActiveEl, closeOthers);

        const mainEl = this.parentNode.parentNode.parentNode;
        const index = [...this.querySelectorAll('.accordion-image-or-video__accordion')].findIndex((el) => el.classList.contains('active'));
        const image_groups = mainEl.querySelectorAll('.accordion-image-or-video__image-group');
        image_groups.forEach((image_group) => image_group.classList.remove('active'));
        image_groups[index].classList.add('active');
      }
    }

    customElements.define("accordion-image-or-video-section-accordions", AccordionImageOrVideoSectionAccordions);
    class serviceInfoAccordions extends Accordion {
      constructor() {
        super(".service-info-accordion__content");
      }
  
      toggleActive(newActiveEl, closeOthers = false) {
        if (newActiveEl.isEqualNode(this.activeEl)) {
          this.closeEl(this.activeEl);
          this.activeEl = null
          return 
        }
        super.toggleActive(newActiveEl, closeOthers);
      }
  
      clickHandler(e) {
        const newActiveEl = e.currentTarget;
        const target = e.target;
        //Expand/Collapse accordion except input
        if(target.nodeName !== 'INPUT') {
          this.toggleActive(newActiveEl);
        }
      }
    }
    customElements.define("service-info-accordions", serviceInfoAccordions);
  } 
});
